export const ListsStyleClasses = {
  STYLE_NONE: ['wf-list-none'],
  STYLE_DECIMAL: ['wf-list-decimal'],
  STYLE_DISC: ['wf-list-disc'],
  STYLE_SQUARE: ['wf-list-square'],
  STYLE_ROMAN: ['wf-list-roman'],
}
